import { DataAccessConfiguration } from './data-access-configuration';
import { Subject } from 'rxjs';

let listener: () => void = function () {
  // No op. Purposely do nothing.
};

export function signalJwtAuthError() {
  listener();
}

export const jwtRefreshedSignal = new Subject<boolean>();

/**
 * DataAccess Environment Class for getting and setting tokens and Configuration
 */
export class DataAccessEnvironment {
  private jwtBacking = '';

  authToken = '';
  pcmWsApiKey = '';
  tidJwt = '';

  set jwt(value: string) {
    this.jwtBacking = value;
    jwtRefreshedSignal.next(true);
  }
  get jwt() {
    return this.jwtBacking;
  }

  refreshToken = '';

  configuration: DataAccessConfiguration = {
    useLegacyTokenForAccountsApi: false,
  };

  onJwtAuthError(callback: () => void) {
    listener = callback;
  }
}

/**
 * Singleton instance of DataAccessEnvironment
 */
export const dataAccessEnvironment = new DataAccessEnvironment();
